<script>
	import formBase from '@_system/components/base/form.vue'
	import unserlineorderBox from './box/unserlineorder.vue'
	export default {
		extends: formBase,
		name: 'universalinvoiceapplyForm',
		props: {

		},
		data() {
			return {
				handle:null
			}

		},
		render(h) {
			this.$slots.plug = [ <unserlineorder-box ref = "unserlineorderBox"
				onSubmit = {
					this.unserlineorderBoxSubmit
				}
				/>
			]
			return formBase.render.call(this, h)
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeInit(next){
				next()
			},
			tableAdd(e) {
				this.handle = e
				this.$refs.unserlineorderBox.initList()
				this.$refs.unserlineorderBox.box.alertBox()
			},
			unserlineorderBoxSubmit(e){
				// console.log(e,this.handle)
				this.handle.obj = {
					universalinvoiceid:e.data.id,
					invoicenumber:e.data.invoicenumber,
					tradecode:e.data.tradecode,
					invoiceType:e.data.invoiceType,
					invoiceamount:e.data.invoiceamount,
				}
				this.handle.next()
			}
		},
		components: {
			unserlineorderBox
		}
	}
</script>
